import {ngAsync} from 'shared/utils/ng-@decorators';
import type {IdentifiedFile} from 'typings/portaro.be.types';

export class FileContentDataService {
    public static serviceName = 'fileContentDataService';
    public static ROUTE = 'files';

    private restangular: Restangular.IService;

    /*@ngInject*/
    constructor(Restangular: Restangular.IService, CONTEXT_PATH: string) {
        this.restangular = Restangular.withConfig((restangularProvider) => restangularProvider.setBaseUrl(CONTEXT_PATH));

    }

    // unRestangularize is not applicable here, because response is plaintext not json
    @ngAsync()
    public async getFileContent(file: IdentifiedFile): Promise<string> {
        return this.restangular
            .one(FileContentDataService.ROUTE, file.id)
            .get<string>();
    }
}